import { render, staticRenderFns } from "./insuranceSetupList.vue?vue&type=template&id=b92e90c2&"
import script from "./insuranceSetupList.vue?vue&type=script&lang=js&"
export * from "./insuranceSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports